<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    class="smith"
    preserveAspectRatio="xMinYMin meet"
    viewBox="0 0 1.1 1.1"
    version="1.1"
    id="svg50"
    sodipodi:docname="abc.svg"
    inkscape:version="0.92.4 (unknown)"
  >
    <metadata id="metadata56">
      <rdf:RDF>
        <cc:Work rdf:about>
          <dc:format>image/svg+xml</dc:format>
          <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage"
          ></dc:type>
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs id="defs54"></defs>
    <sodipodi:namedview
      pagecolor="#ffffff"
      borderColor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="1920"
      inkscape:window-height="1016"
      id="namedview52"
      showgrid="false"
      inkscape:zoom="256"
      inkscape:cx="0.5921084"
      inkscape:cy="0.67018532"
      inkscape:window-x="0"
      inkscape:window-y="27"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg50"
    ></sodipodi:namedview>
    <path
      inkscape:connector-curvature="0"
      style="fill:#77777f;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="path2-3"
      d="M 1.0613634,0.02569117 H 0.03863658 c -0.007241,0 -0.01311188,0.0058645 -0.01311188,0.01311188 0,0.0072474 0.0058709,0.01311189 0.01311188,0.01311189 H 0.23223533 V 0.12568209 H 0.09025181 c -0.007241,0 -0.01311188,0.005864 -0.01311188,0.0131119 v 0.67416075 c 0,0.002458 6.9152e-4,0.004866 0.0019911,0.006953 L 0.20446861,1.0205168 c 0.0210443,0.033676 0.0573197,0.053792 0.0970395,0.053792 h 0.49698388 c 0.0397198,0 0.0759951,-0.020116 0.0970395,-0.053792 L 1.020869,0.81990761 c 0.0013,-0.002087 0.00199,-0.004494 0.00199,-0.006953 V 0.13879397 c 0,-0.007247 -0.00587,-0.0131119 -0.013112,-0.0131119 H 0.86776468 V 0.05191494 H 1.0613634 c 0.00724,0 0.013112,-0.0058645 0.013112,-0.01311189 0,-0.0072474 -0.00587,-0.01311188 -0.013112,-0.01311188 z M 0.99663632,0.80919018 0.87328986,1.0066111 C 0.85707286,1.0325791 1.0422217,0.78794009 1.0133357,0.7980851 l -0.71182763,0.25 C 0.27262209,1.0582301 1.0128533,0.83515818 0.99663631,0.80919018 H 0.1033637 0.99663632 l -1e-8,-0.65728433 V 0.80919018 Z M 0.84154092,0.12568209 H 0.2584591 V 0.05191494 h 0.58308182 z"
      sodipodi:nodetypes="ssssccsssccssccsssccsssccssccccccccccc"
    ></path>
    <path
      inkscape:connector-curvature="0"
      style="fill:#ffffff;fill-opacity:1;stroke-width:0.01311188"
      id="path4-6"
      d="m 0.42414484,0.5241988 -0.006389,0.12201478 c -2.305e-4,0.00443 0.00179,0.008682 0.00538,0.0112936 0.00359,0.002612 0.00826,0.00324 0.012395,0.001639 l 0.1145241,-0.0437788 0.1145625,0.0438557 c 0.00152,5.8904e-4 0.0031,8.7074e-4 0.00469,8.7074e-4 0.00273,0 0.00544,-8.5792e-4 0.00771,-0.00251 0.00359,-0.002612 0.00562,-0.006863 0.00538,-0.0112936 l -0.00647,-0.12201477 0.077154,-0.0949331 c 0.0028,-0.003457 0.00367,-0.008092 0.0023,-0.012318 -0.00137,-0.004226 -0.0048,-0.007478 -0.00909,-0.008617 l -0.1185186,-0.031666 -0.06684,-0.10252622 c -0.00484,-0.007427 -0.017132,-0.007427 -0.021973,0 l -0.066763,0.102475 -0.1184871,0.0315889 c -0.0043,0.00114 -0.00772,0.004392 -0.00909,0.008617 -0.00137,0.004225 -5.057e-4,0.008861 0.0023,0.012318 z m 0.059669,-0.1234745 c 0.00312,-8.3238e-4 0.00584,-0.002791 0.00761,-0.005506 l 0.0663425,0.0898506 0.0507815,-0.0897994 c 0.00177,0.002715 0.00448,0.004674 0.0076,0.005506 l -0.1305619,0.0746097 0.166805,0.0362651 c -0.037969,-0.0168488 -0.166975,-0.0395041 -0.166805,-0.0362651 l 0.0211175,0.0466649 0.0480432,0.0670422 c -0.00151,-5.7632e-4 -0.0031,-8.7073e-4 -0.00469,-8.7073e-4 -0.00159,0 -0.00318,2.9451e-4 -0.00468,8.7073e-4 l 0.0123897,-0.1040235 -0.1071711,0.0354678 c 1.728e-4,-0.003252 -8.707e-4,-0.006441 -0.00292,-0.008963 l 0.16674665,-0.0167722 z"
      sodipodi:nodetypes="ccccccsccccsccccccsccccccccccccscccccc"
    ></path>
    <path
      inkscape:connector-curvature="0"
      style="fill:#ffffff;fill-opacity:1;stroke-width:0.01311188"
      id="path6-7"
      d="m 0.35709276,0.77600073 h 0.3858145 c 0.00724,0 0.013112,-0.005865 0.013112,-0.0131119 0,-0.007247 -0.00587,-0.0131119 -0.013112,-0.0131119 h -0.3858145 c -0.00724,0 -0.013112,0.005864 -0.013112,0.0131119 0,0.007247 0.00587,0.0131119 0.013112,0.0131119 z"
    ></path>
    <path
      inkscape:connector-curvature="0"
      style="fill:#ffffff;fill-opacity:1;stroke-width:0.01311188"
      id="path8-5"
      d="m 0.35709276,0.90746527 h 0.3858145 c 0.00724,0 0.013112,-0.005864 0.013112,-0.0131119 0,-0.007247 -0.00587,-0.0131119 -0.013112,-0.0131119 h -0.3858145 c -0.00724,0 -0.013112,0.005865 -0.013112,0.0131119 0,0.007247 0.00587,0.0131119 0.013112,0.0131119 z"
    ></path>
    <rect
      style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect851"
      width="0.16015625"
      height="0.12890625"
      x="0.42578125"
      y="0.43203127"
    ></rect>
    <rect
      style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect853"
      width="0.094513662"
      height="0.036812972"
      x="0.49142385"
      y="0.39521831"
    ></rect>
    <rect
      style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect855"
      width="0.1687324"
      height="0.048531722"
      x="0.49142385"
      y="0.39521831"
    ></rect>
    <rect
      style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect857"
      width="0.048043199"
      height="0.067042202"
      x="0.50670344"
      y="0.52205008"
    ></rect>
    <rect
      style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect861"
      width="0.0234375"
      height="0.00390625"
      x="0.51171875"
      y="0.35390627"
    ></rect>
    <rect
      style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect863"
      width="0.1306081"
      height="0.13698889"
      x="0.45059523"
      y="-1.6164522"
    ></rect>
  </svg>
</template>

<script>
export default {
  name: "agency"
};
</script>
